import { chatbotConstants } from '../../constants/chatbot.constants';

function setChatMessagesToStore(payload) {
  return { type: chatbotConstants.CHATMESSAGES, payload };
}

export const chatbotActions = {
  setChatMessagesToStore,
};
